import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnLoaderComponent } from './dn-loader.component';

@NgModule({
  declarations: [DnLoaderComponent],
  exports: [DnLoaderComponent],
  imports: [CommonModule],
})
export class DnLoaderModule {}
